import { createSlice } from '@reduxjs/toolkit';
import { Slices } from 'ducks/slices';
import { getSystemParameters } from 'ducks/system-parameters-list/operators';
import { normalizeAndSortSystemParameters } from 'ducks/system-parameters-list/utils';
import { UnionFromArray } from 'ducks/types/type-helpers';

export type SystemParametersListItem = UnionFromArray<ReturnType<typeof normalizeAndSortSystemParameters>>;

const initialState: SystemParametersListItem[] = [];

const systemParametersListSlice = createSlice({
  name: Slices.SYSTEM_PARAMETERS_LIST,
  initialState,
  reducers: {
    clearSystemParametersList: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSystemParameters.pending, () => {
        return initialState;
      })
      .addCase(getSystemParameters.fulfilled, (_, { payload }) => {
        return normalizeAndSortSystemParameters(payload);
      })
      .addCase(getSystemParameters.rejected, () => {
        return initialState;
      });
  },
});

export const { clearSystemParametersList } = systemParametersListSlice.actions;

export default systemParametersListSlice.reducer;
